import { useEffect } from "react";
import { useParams } from "react-router-dom";
import "./style.css";
import TermsAndCondition from "./TermsAndCondition";
import useDiwaliHook from "./useDiwaliHook";
import { getWinnerImg, getWinnerTerms } from "./constants";

const WinnerContainer = () => {
  const { winnerPageData, handleBackBtn, lang } = useDiwaliHook();
  const { id }: any = useParams();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (id !== '1' && id !== '2' && id !== '3') {handleBackBtn()}
  }, []);

  return (
    <div className="main_container">
      <img src={winnerPageData?.backBtn} alt="back-btn" className="back_btn" onClick={handleBackBtn} />
      <h1 className="diwali_dhamaka_container">
        <img src={winnerPageData?.winnerDiwaliDhamakaImg} alt="diwali-dhamaka" className="diwali_dhamaka" />
      </h1>
      <h2 className="winner_heading"> { id === '1' ? winnerPageData?.dailyWinnerHeading  : (id === '2' ? winnerPageData?.dailyWinnerHeadingInactive : winnerPageData?.weeklyWinnerHeading )} </h2>
      <div className="winner_content">
        <img src={getWinnerImg(id, lang)} alt="winner_content" className="winner_img" />
      </div>
      <TermsAndCondition src={getWinnerTerms(id, lang)} />
    </div>
  );
};

export default WinnerContainer;
